// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__6eZuA","image":"Header_image__1HPRY","name":"Header_name__3c-Vi","info":"Header_info__3Iy6v","infoRow":"Header_infoRow__2hfz7"};